// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store/index.js'
import 'babel-polyfill'
import i18n from '@/lang/index.js'
import '@/assets/css/common.css'
import '@/assets/css/customize-element-ui.css'
// import animate from 'animate.css';
// import echarts from '@/echarts/index.js';
import element from '@/element-ui/index.js'
import VueLazyload from 'vue-lazyload'
import '@/assets/icons'

//全局引入Element的 css样式
import 'element-ui/lib/theme-chalk/index.css'
// Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(element)
Vue.use(VueLazyload, {
  preLoad: 1.3,
  listenEvents: ['resize', 'scroll', 'wheel', 'mousewheel', 'animationend', 'transitionend']
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    let lang = store.getters.getLang
    let arr = to.meta.title.split('.')
    let temp = i18n.messages[lang][arr[0]]
    for (let index = 1; index < arr.length; ++index) {
      temp = temp[arr[index]]
    }
    if (lang === 'zh' && to.meta.title == 'jobs') {
      window.location.href = 'https://app.mokahr.com/social-recruitment/dizalpharmaceutical/72251'
    } else if (lang === 'en' && to.meta.title == 'jobs') {
      window.location.href = 'https://app.mokahr.com/social-recruitment/dizalpharmaceutical/72240'
    }
    document.title = temp
  }
  next()
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js